import React, { useEffect, useState } from "react";
import { Button, Text } from "components";
import { useNavigate } from "react-router-dom";
import CreditNoteList from "./CreditNote/CreditNoteList";
import DebitNoteList from "./DebitNote/DebitNoteList";
import axios from "axios";
import Select from "react-select";
import CustomerDebitNoteList from "./CustomerDebitNote/CustomerDebitNoteList";
import Tabs from "components/TabNavBar/Tab";

const tabItems = [
  {
    label: "Customer Debit-Note",
    value: "CustDebitNote",
  },
  {
    label: "Supplier Debit-Note",
    value: "SuppDebitNote",
  },
];

function DebitNoteTab() {
  const [download, setDownload] = useState(false);
  const [activeTab, setActiveTab] = useState();
  const childRef = React.useRef(null);
  const [erplist, setErplist] = useState([]);
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("column");
  const [searchParameter, setsearchParameter] = useState("");
  const [searchParameter2, setsearchParameter2] = useState("");
  const [searchCompanySpecificCriteriaId, setsearchCompanySpecificCriteriaId] =
    useState();
  const [
    searchCompanySpecificDateRangeId,
    setsearchCompanySpecificDateRangeId,
  ] = useState();
  const [searchCompanySpecificCriteria, setsearchCompanySpecificCriteria] =
    useState([]);
  const [searchcompanyspecificdaterange, setsearchcompanyspecificdaterange] =
    useState([]);
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [page, setPage] = useState(1);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    if (activeTab === "CustDebitNote") {
      getsearchCompanySpecificCriteria();
    }
    if (activeTab === "SuppDebitNote") {
      getsearchCompanySpecificCriteriaforDebit();
    }
    getsetsearchcompanyspecificdaterange();
  }, [activeTab]);
  const getsearchCompanySpecificCriteria = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 26 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getsearchCompanySpecificCriteriaforDebit = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 27 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getsetsearchcompanyspecificdaterange = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificdaterange/get",
        {},
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchcompanyspecificdaterange(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");
    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  useEffect(() => {
    setActiveTab(
      sessionStorage.getItem("tab") === "CustDebitNote"
        ? "CustDebitNote"
        : sessionStorage.getItem("tab")
    );
  }, []);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.id);
  };

  const onhandler = () => {
    if (activeTab === "CustDebitNote") {
      navigate("/creditNote/add");
    }
    if (activeTab === "SuppDebitNote") {
      navigate("/debitNote/add");
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem("tab", tab);
  };

  function downloadExcel() {
    childRef.current.downloadExcel();
  }
  function downloadPdf() {
    childRef.current.downloadPdf();
  }

  return (
    <>
      {erplist.some((item) => item.erp_module_id === 31 && item.view) ? (
        <div className="w-full flex flex-col">
          <div className="flex flex-row flex-wrap w-full items-center justify-between px-2 pt-2">
            {/* Left Section */}
            <div className="flex flex-row items-center gap-4 flex-wrap">
              <Text
                className="text-base md:text-[22px]  text-gray-800 sm:text-xl tracking-[0.20px] w-[85px] whitespace-nowrap"
                size="txtInterSemiBold24"
              >
                Debit-Note
              </Text>

              <>
                <span className="text-sm text-gray-600 font-medium ml-4">
                  Search By:
                </span>

                {/* Radio Buttons */}
                <div className="flex items-center gap-2">
                  <input
                    type="radio"
                    id="column"
                    name="option"
                    checked={selectedOption === "column"}
                    onChange={(event) => {
                      handleOptionChange(event);
                      setsearchCompanySpecificDateRangeId("");
                      setsearchParameter("");
                      setPage(1);
                    }}
                    className="scale-100"
                  />
                  <label htmlFor="column" className="text-gray-600 text-sm">
                    Column
                  </label>

                  <input
                    type="radio"
                    id="date"
                    name="option"
                    checked={selectedOption === "date"}
                    onChange={(event) => {
                      handleOptionChange(event);
                      setsearchCompanySpecificCriteriaId("");
                      setsearchParameter("");
                      setPage(1);
                    }}
                    className="scale-100"
                  />
                  <label htmlFor="date" className="text-gray-600 text-sm">
                    Date
                  </label>
                </div>

                {/* Dropdown based on selectedOption */}
                {selectedOption === "column" && (
                  <>
                    <Select
                      options={searchCompanySpecificCriteria.map(
                        (resstate) => ({
                          label: resstate.criteria,
                          value: resstate.id,
                        })
                      )}
                      className="bg-white-A700 border border-gray-200_02"
                      onChange={(selectedoption) => {
                        setsearchCompanySpecificCriteriaId(
                          selectedoption.value
                        );
                        setPage(1);
                      }}
                      value={
                        searchCompanySpecificCriteria.find(
                          (option) =>
                            option.id === searchCompanySpecificCriteriaId
                        )
                          ? {
                              label: searchCompanySpecificCriteria.find(
                                (option) =>
                                  option.id === searchCompanySpecificCriteriaId
                              )?.criteria,
                              value: searchCompanySpecificCriteriaId,
                            }
                          : null
                      }
                      styles={{
                        control: (base) => ({
                          ...base,
                          height: "30px",
                          width: "140px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }),
                      }}
                    />
                    <input
                      name="searchParameter"
                      type="text"
                      placeholder="Search..."
                      value={searchParameter}
                      onChange={(e) => {
                        setsearchParameter(e.target.value);
                        setPage(1);
                      }}
                      className="bg-white-A700 border border-gray-400_02 h-9 rounded-[5px] w-40 px-2"
                    />
                  </>
                )}

                {selectedOption === "date" && (
                  <>
                    <Select
                      options={searchcompanyspecificdaterange.map(
                        (resstate) => ({
                          label: resstate.date_range,
                          value: resstate.search_date_range_id,
                        })
                      )}
                      className="bg-white-A700 border border-gray-200_02"
                      onChange={(selectedoption) => {
                        setsearchCompanySpecificDateRangeId(
                          selectedoption.value
                        );
                        setPage(1);
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          height: "30px",
                          width: "140px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }),
                      }}
                    />
                    {searchCompanySpecificDateRangeId === 7 && (
                      <div className="flex items-center gap-2">
                        <input
                          name="from_date"
                          type="date"
                          onChange={(e) => {
                            setFormDate(e.target.value);
                            setsearchParameter2(
                              e.target.value.concat("@" + toDate)
                            );
                            setPage(1);
                          }}
                          className="bg-white-A700 border border-gray-400_02 h-9 rounded-[5px] px-2"
                        />
                        <span className="text-gray-600">To</span>
                        <input
                          name="to_date"
                          type="date"
                          onChange={(e) => {
                            setToDate(e.target.value);
                            setsearchParameter2(
                              formDate.concat("@" + e.target.value)
                            );
                            setPage(1);
                          }}
                          className="bg-white-A700 border border-gray-400_02 h-9 rounded-[5px] px-2"
                        />
                      </div>
                    )}
                  </>
                )}
              </>
            </div>

            {/* Right Section (Download + Add buttons) */}
            <div className="flex flex-row items-center gap-4">
              <div
                className="relative z-20"
                onMouseEnter={() => setDownload(true)}
                onMouseLeave={() => setDownload(false)}
              >
                <button
                  type="button"
                  className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 inline-flex items-center"
                >
                  Download &nbsp;
                  <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 10 6">
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                {download && (
                  <div className="absolute top-[32px] z-20 bg-white rounded-lg shadow w-[110px]">
                    <ul className="py-0 text-sm text-gray-700">
                      <li>
                        <span
                          className="block px-4 py-2 hover:bg-gray-100 cursor-pointer"
                          onClick={downloadPdf}
                        >
                          PDF
                        </span>
                      </li>
                      <li>
                        <span
                          className="block px-4 py-2 hover:bg-gray-100 cursor-pointer"
                          onClick={downloadExcel}
                        >
                          Excel
                        </span>
                      </li>
                    </ul>
                  </div>
                )}
              </div>

              {erplist.some(
                (item) => item.erp_module_id === 60 && item.add
              ) && (
                <button
                  type="button"
                  className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5"
                  onClick={() => onhandler()}
                >
                  + Add
                </button>
              )}
            </div>
          </div>

          {/* <div className="w-full">
            <nav className=" p-1 bg-slate-100">
              <div className="container mx-auto">
                <ul className="flex">
                  <li
                    className={`mr-6 ml-6 p-2 w-30 text-sm ${
                      activeTab === "CustDebitNote"
                        ? "bg-gray-150 text-blue-500 shadow-md"
                        : ""
                    }`}
                  >
                    <Button
                      className="text-white"
                      onClick={() => {
                        handleTabClick("CustDebitNote");
                      }}
                    >
                      Customer Debit-Note
                    </Button>
                  </li>
                  <li
                    className={`mr-6 p-2 w-30 text-sm ${
                      activeTab === "SuppDebitNote"
                        ? "bg-gray-150 text-blue-500 shadow-md"
                        : ""
                    }`}
                  >
                    <Button
                      className="text-white"
                      onClick={() => {
                        handleTabClick("SuppDebitNote");
                      }}
                    >
                      Supplier Debit-Note
                    </Button>
                  </li>
                </ul>
              </div>
            </nav>
          </div> */}
          <Tabs
            tabs={tabItems}
            activeTab={activeTab}
            onTabChange={handleTabClick}
          />
          <div>
            {activeTab === "CustDebitNote" && (
              <CustomerDebitNoteList
                ref={childRef}
                searchParameter={searchParameter}
                searchParameter2={searchParameter2}
                selectedOption={selectedOption}
                searchCompanySpecificCriteriaId={
                  searchCompanySpecificCriteriaId
                }
                searchCompanySpecificDateRangeId={
                  searchCompanySpecificDateRangeId
                }
                formDate={formDate}
                toDate={toDate}
                page={page}
                setPage={setPage} // if you want to update the page from within child
              />
            )}
            {activeTab === "SuppDebitNote" && (
              <DebitNoteList
                ref={childRef}
                searchParameter={searchParameter}
                searchParameter2={searchParameter2}
                selectedOption={selectedOption}
                searchCompanySpecificCriteriaId={
                  searchCompanySpecificCriteriaId
                }
                searchCompanySpecificDateRangeId={
                  searchCompanySpecificDateRangeId
                }
                formDate={formDate}
                toDate={toDate}
                page={page}
                setPage={setPage}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
}

export default DebitNoteTab;
